var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcManifiestoEmpresas = function SvgIcManifiestoEmpresas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.4166C15.6916 12.4166 16.25 11.8583 16.25 11.1666C16.25 10.475 15.6916 9.91665 15 9.91665C14.3083 9.91665 13.75 10.475 13.75 11.1666C13.75 11.8583 14.3083 12.4166 15 12.4166ZM16.25 4.91665H14.1666V6.99998H17.8833L16.25 4.91665ZM4.99998 12.4166C5.69165 12.4166 6.24998 11.8583 6.24998 11.1666C6.24998 10.475 5.69165 9.91665 4.99998 9.91665C4.30831 9.91665 3.74998 10.475 3.74998 11.1666C3.74998 11.8583 4.30831 12.4166 4.99998 12.4166ZM16.6666 3.66665L19.1666 6.99998V11.1666H17.5C17.5 12.55 16.3833 13.6666 15 13.6666C13.6166 13.6666 12.5 12.55 12.5 11.1666H7.49998C7.49998 12.55 6.38331 13.6666 4.99998 13.6666C3.61665 13.6666 2.49998 12.55 2.49998 11.1666H0.833313V1.99998C0.833313 1.07498 1.57498 0.333313 2.49998 0.333313H14.1666V3.66665H16.6666ZM2.49998 1.99998V9.49998H3.13331C3.59165 8.99165 4.25831 8.66665 4.99998 8.66665C5.74165 8.66665 6.40831 8.99165 6.86665 9.49998H12.5V1.99998H2.49998Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcManifiestoEmpresas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_manifiesto_empresas.50153ead.svg";
export { ForwardRef as ReactComponent };